<template>
    <div class="number-stepper">
        <button
            class="touch-manipulation"
            :class="{ disabled: ! canDecrease() }"
            @mousedown="startDecrease"
            @mouseup="stopInterval"
            @mouseleave="stopInterval"
            @touchend.passive="stopInterval"
            @touchcancel.passive="stopInterval"
            @keydown.enter.prevent="decrease()"
        >−</button>

        <div class="w-12 mx-2 select-none">
            <input
                type="text"
                class="text-center"
                :maxlength="maxLength"
                :id="name"
                :value="quantity"
                @input="onInputChange($event)"
                @focusout="onInputBlurOutside($event)"
                @keydown.enter="onEnter?.()"
                ref="numberInput"
            >
        </div>

        <button
            class="touch-manipulation"
            :class="{ disabled: ! canIncrease() }"
            @mousedown="startIncrease"
            @mouseup="stopInterval"
            @mouseleave="stopInterval"
            @touchend.passive="stopInterval"
            @touchcancel.passive="stopInterval"
            @keydown.enter.prevent="increase()"
        >+</button>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "NumberStepper",

    props: [
        "name",
        "quantity",
        "onChange",
        "onCanIncrease",
        "onCanDecrease",
        "onEnter",
        "max",
    ],

    data() {
        return {
            interval: null,
            intervalStartup: null,
            triggerMs: 200,
            startupMs: 500,
            maxValue: this.max ?? 99,
        }
    },

    methods: {
        canDecrease() {
            return this.onCanDecrease?.() ?? true;
        },
        canIncrease() {
            return this.onCanIncrease?.() ?? true;
        },

        increase() {
            if (this.canIncrease()) {
                this.onChange(this.quantity + 1);
            }
        },

        decrease() {
            if (this.canDecrease()) {
                this.onChange(this.quantity - 1);
            }
        },

        startDecrease() {
            this.stopInterval();
            this.decrease();

            this.intervalStartup = setTimeout(() => {
                this.interval = setInterval(
                    () => this.decrease(),
                    this.triggerMs
                );
            }, this.startupMs);
        },

        startIncrease() {
            this.stopInterval();
            this.increase();

            this.intervalStartup = setTimeout(() => {
                this.interval = setInterval(
                    () => this.increase(),
                    this.triggerMs
                );
            }, this.startupMs);
        },


        onInputChange(event) {
            const inputValue = event.target.value;
            if (inputValue !== '') {
                // Remove non-digit characters
                let number = Number(inputValue.replace(/\D/g, ''));
                if (number > this.maxValue) {
                    number = this.maxValue;
                    this.$refs.numberInput.value = number.toString();
                }
                this.onChange(number);
            }
        },

        onInputBlurOutside(event) {
            const inputElement = event.target;
            const inputValue = inputElement.value.trim(); // Remove leading and trailing spaces

            if (inputValue === '') {
                this.onChange(0);
            }
        },

        stopInterval() {
            clearTimeout(this.intervalStartup);
            clearInterval(this.interval);
        },
    },

    computed: {
        maxLength() {
            return this.maxValue.toString().length;
        }
    }

})
</script>
